<template>
    <div>
        <loader-spin></loader-spin>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {

        }
    },
    async mounted() {
        const token = this.$route.query.token;
        if (!token) this.$store.commit('changeErrorMsg', 'Validation du compte échouée');

        try {
            const res = await axios.put(this.$store.getters.get_api_url + 'auth/email-verified/' + token);
            this.$store.commit('changeValidationMsg', res.data.message || 'Adresse email verifiée');

            if (res.data.resetToken) {
                this.$router.replace(`/reset-password?reset_token=${res.data.resetToken}`);
            } else {
                this.$router.replace('/welcome');
            }
        } catch {
            this.$store.commit('changeErrorMsg', 'Le lien a expiré');
            this.$router.replace('/welcome');
        }
    }
}
</script>

<style scoped>

</style>